import React from 'react';
import PropTypes from "prop-types";
import Control from "../Control";
import {formatDate, formatNumber, formatPhoneNumber, percent} from "../../utils";
import close from '../../svgs/X.svg';

const DualRange = ({theme = 'default', minValue = '', maxValue = '', minName, maxName, valueType = 'text', label, viewMode, decimals = 2, handleParentChange, className = "", deleted = false, isDollar, ...rest}) => {
    const formatValue = (value, type) => {
        switch (type) {
            case 'number':
            case 'percent':
                return formatNumber(value);
            case 'integer': // price - with commas
            case 'float':   // price - with commas and decimals
                return formatNumber(value, true);
            case 'date':
                return formatDate(value);
        }
        return value;
    };

    const formatViewValue = (value) => {
        if (!value) return '-';
        switch (valueType) {
            case 'number':
                return formatNumber(value);
            case 'integer':
                return isDollar ? `$${value}` : value;
            case 'float':
                return isDollar ? `$${value}` : value;
            case 'phone':
                return formatPhoneNumber(value);
            case 'date':
                return formatDate(value);
            case 'percent':
            case 'agent-percent':
                return percent(value);
            default:
                return value;
        }
    };

    const handleChange = (e) => {
        const key = e.currentTarget.name;
        const value = formatValue(e.currentTarget.value, valueType);
        handleParentChange(key, value);
        return value;
    };

    const handleBlur = (e) => {
        const key = e.currentTarget.name;
        let value = e.currentTarget.value;

        if (value && ['float', 'percent'].includes(valueType)) {
            const hasCommas = valueType === 'float';
            value = formatNumber(value, hasCommas, decimals);
        }
        handleParentChange(key, value);
        return value;
    };

    const handleReset = () => {
        handleParentChange(minName, '');
        handleParentChange(maxName, '');
    };

    const disabled = rest.disabled;
    const minVal = formatValue(minValue, valueType);
    const maxVal = formatValue(maxValue, valueType);
    const placeholderMin = valueType === 'date' ? 'MM/DD/YYYY' : 'Min';
    const placeholderMax = valueType === 'date' ? 'MM/DD/YYYY' : 'Max';
    const viewValMin = formatViewValue(minVal);
    const viewValMax = formatViewValue(maxVal);
    if (valueType === 'date') rest.pattern = '(0?[1-9]|1[012])[/](0?[1-9]|[12][0-9]|3[01])[/]([1|2]\\d{3})';

    return (
        <div className={`dual-range-container ${className}`}>
            <label className={`dual-range-label ${theme}${disabled ? ' disabled': ''}`}>{label}</label>
            {
                !viewMode &&
                <div className={`dual-range-input-wrapper ${theme}`}>
                    <input className={`dual-range-input ${theme}${disabled ? ' disabled': ''}`}
                           type='text'
                           value={minVal}
                           name={minName}
                           onChange={handleChange}
                           onBlur={handleBlur}
                           placeholder={placeholderMin}
                           {...rest}
                    />
                    <input className={`dual-range-input ${theme}${disabled ? ' disabled': ''}`}
                           type='text'
                           value={maxVal}
                           name={maxName}
                           onChange={handleChange}
                           onBlur={handleBlur}
                           placeholder={placeholderMax}
                           {...rest}
                    />
                    <Control onClick={handleReset}
                             className={`dual-range-reset${disabled ? ' disabled': ''}`}
                             dangerouslySetInnerHTML={{__html: close}}/>
                </div>
            }
            {
                viewMode &&
                <div className={`dual-range-text-wrapper ${theme} ${deleted ? "dual-range-deleted" : ""}`}>
                    <div className='dual-range-text'>{viewValMin}</div>
                    <div className='dual-range-text'>{viewValMax}</div>
                </div>
            }
        </div>
    )
};

DualRange.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark']),
    minValue: PropTypes.string,
    maxValue: PropTypes.string,
    minName: PropTypes.string.isRequired,
    maxName: PropTypes.string.isRequired,
    valueType: PropTypes.oneOf(['text', 'number', 'integer', 'float', 'percent', 'date']),
    label: PropTypes.string,
    decimals: PropTypes.number,
    handleParentChange: PropTypes.func.isRequired,
    viewMode: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    deleted: PropTypes.bool,
};

export default DualRange;